import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faCalendarAlt,
  faSignOutAlt,
  faStar,
  faCog,
  faChartLine,
  faUserMd,
  faCalendarCheck,
  faUser
} from '@fortawesome/free-solid-svg-icons';

const DoctorSidebar = () => {
  // Ottenere le informazioni dell'utente dal localStorage
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const firstName = user.first_name || '';
  const lastName = user.last_name || '';
  const userId = user.id || '';

  return (
    <div className="flex flex-col h-full">
      {/* Intestazione con informazioni del dottore */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center">
          <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center mr-3">
            <FontAwesomeIcon icon={faUserMd} className="text-purple-600" />
          </div>
          <div>
            <h3 className="font-medium text-gray-800">{firstName} {lastName} (#{userId})</h3>
          </div>
        </div>
      </div>

      <nav className="mt-6 flex-grow">
        <Link
          to="/doctor/dashboard"
          className="flex items-center px-4 py-2 hover:bg-purple-100 text-gray-700"
        >
          <FontAwesomeIcon icon={faHome} className="mr-3" />
          Dashboard
        </Link>

        <Link
          to="/doctor/appointments"
          className="flex items-center px-4 py-2 hover:bg-purple-100 text-gray-700"
        >
          <FontAwesomeIcon icon={faCalendarAlt} className="mr-3" />
          Appuntamenti
        </Link>

        <Link
          to="/doctor/calendar"
          className="flex items-center px-4 py-2 hover:bg-purple-100 text-gray-700"
        >
          <FontAwesomeIcon icon={faCalendarCheck} className="mr-3" />
          Calendario
        </Link>

        <Link
          to="/doctor/patient"
          className="flex items-center px-4 py-2 hover:bg-purple-100 text-gray-700"
        >
          <FontAwesomeIcon icon={faUser} className="mr-3" />
          Pazienti
        </Link>

        {/* Intestazione con informazioni del dottore 
        <Link
          to="/doctor/messages"
          className="flex items-center px-4 py-2 hover:bg-purple-100 text-gray-700"
        >
          <FontAwesomeIcon icon={faEnvelope} className="mr-3" />
          Messaggi
        </Link>
        */}
        <Link
          to="/doctor/feedback"
          className="flex items-center px-4 py-2 hover:bg-purple-100 text-gray-700"
        >
          <FontAwesomeIcon icon={faStar} className="mr-3" />
          Feedback
        </Link>

        <Link
          to="/doctor/stats"
          className="flex items-center px-4 py-2 hover:bg-purple-100 text-gray-700"
        >
          <FontAwesomeIcon icon={faChartLine} className="mr-3" />
          Statistiche
        </Link>

        <Link
          to="/doctor/settings"
          className="flex items-center px-4 py-2 hover:bg-purple-100 text-gray-700"
        >
          <FontAwesomeIcon icon={faCog} className="mr-3" />
          Impostazioni
        </Link>

        <Link
          to="/patient/login"
          className="flex items-center px-4 py-2 hover:bg-purple-100 text-gray-700"
        >
          <FontAwesomeIcon icon={faSignOutAlt} className="mr-3" />
          Logout
        </Link>

        {/* Pulsante di assistenza */}
        <div className="h-6"></div>
        <div className="p-4">
          <a
            href="mailto:help@personaltherapy.it"
            className="block bg-purple-600 text-white p-4 rounded-lg shadow-lg hover:bg-purple-700 transition-colors text-center"
          >
            <h3 className="font-bold">Hai bisogno di assistenza  ?</h3>
            <p className="text-sm">Scrivi subito a help@personaltherapy.it !</p>
          </a>
        </div>

      </nav>
    </div>
  );
};

export default DoctorSidebar;